// _variables.scssと重複してるのでどちらも変更の必要あり・・・
export const sizes = {
  fullWidth: 1920, // PCデザイン画面の幅
  spWidth: 390, // スマホデザイン画面の幅
  maxWidth: 1280, // コンテンツの最大幅
  narrowWidth: 840, // 記事とかの狭いコンテンツの最大幅
  breakPoint: 768,
};
